export function numberFormatter(
  numberString: string | number | undefined
): string {
  const formatter = new Intl.NumberFormat().format
  const number = Number(numberString || 0)

  if (isNaN(number)) return formatter(0)

  return formatter(number || 0)
}

export function clamp(value: number, min: number, max: number) {
  return Math.min(Math.max(value, min), max)
}
